import { get } from "../common/remote/base_api";

export const GetSupportdetails = (id) => {
  return get(`caller/get-request-details/`, { request_id: id });
};
